import React from "react";

import connect from "../../../i18n/connect";
import Checkbox from "../../Checkbox/Checkbox";

function FormsyComposedNewCheckboxGroup({
  label,
  value,
  indeterminate,
  onGroupChange,
  translate,
  labelClassName,
  className
}) {
  return (
    <Checkbox
      label={translate(label)}
      checked={!!value}
      indeterminate={indeterminate}
      onClick={onGroupChange}
      labelClassName={labelClassName}
      className={className}
    />
  );
}

export default connect()(FormsyComposedNewCheckboxGroup);
